module.exports = __webpack_public_path__ + "img/thumb-018.da199948.png";